import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Home from './pages/Home';
import CreateClub from './pages/CreateClub';
import EditClub from './pages/EditClub';
import ClubPage from './pages/ClubPage';
import Login from './pages/Login';
import Register from './pages/Register';
import MyClubs from './pages/MyClubs';
import MyCreatedClubs from './pages/MyCreatedClubs';
import Profile from './pages/Profile';
import EditProfile from './pages/EditProfile';
import ChangePassword from './pages/ChangePassword';
import UserProfile from './pages/UserProfile';
import VDOTConfig from './pages/VDOTConfig';
import RecommendedClubs from './pages/RecommendedClubs';
import MyCalendar from './pages/MyCalendar';
import MapView from './pages/MapView';
import FollowingClubs from './pages/FollowingClubs';
import { Analytics } from '@vercel/analytics/react';
import Updates from './pages/Updates';
import AdminUpdates from './pages/AdminUpdates';
import NotificationPrompt from './components/NotificationPrompt';
import StravaActivities from './pages/StravaActivities';  // ✨ AJOUTER ICI
import CreateChallenge from './pages/CreateChallenge';  // ✨ AJOUTER
import ClubChallenges from './pages/ClubChallenges';    // ✨ AJOUTER
import ChallengePage from './pages/ChallengePage';      // ✨ AJOUTER
import ClubWarPage from './pages/ClubWarPage';
import ClubsLeaderboard from './components/ClubsLeaderboard';
import FindFriends from './pages/FindFriends';
import ClubsListPage from './pages/ClubsListPage';
import GlobalLeaderboard from './pages/GlobalLeaderboard';
import Support from './pages/Support';
import PrivacyPolicy from './pages/PrivacyPolicy';

// Composant pour protéger les routes
function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <p className="text-xl text-gray-600">Chargement...</p>
      </div>
    );
  }
  
  return isAuthenticated ? children : <Navigate to="/login" />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/" element={<Home />} />
      <Route path="/create" element={
        <ProtectedRoute>
          <CreateClub />
        </ProtectedRoute>
      } />
      <Route path="/edit-club/:id" element={
        <ProtectedRoute>
          <EditClub />
        </ProtectedRoute>
      } />
      <Route path="/my-clubs" element={
        <ProtectedRoute>
          <MyClubs />
        </ProtectedRoute>
      } />
      <Route path="/my-created-clubs" element={
        <ProtectedRoute>
          <MyCreatedClubs />
        </ProtectedRoute>
      } />
      <Route path="/profile" element={
        <ProtectedRoute>
          <Profile />
        </ProtectedRoute>
      } />
      <Route path="/edit-profile" element={
        <ProtectedRoute>
          <EditProfile />
        </ProtectedRoute>
      } />
      <Route path="/change-password" element={
        <ProtectedRoute>
          <ChangePassword />
        </ProtectedRoute>
      } />
      <Route path="/vdot-config" element={
        <ProtectedRoute>
          <VDOTConfig />
        </ProtectedRoute>
      } />
      <Route path="/recommended-clubs" element={
        <ProtectedRoute>
          <RecommendedClubs />
        </ProtectedRoute>
      } />
      <Route path="/following-clubs" element={<FollowingClubs />} />
      <Route path="/calendar" element={
        <ProtectedRoute>
          <MyCalendar />
        </ProtectedRoute>
      } />

      {/* ✨ AJOUTER ICI */}
      <Route path="/strava-activities" element={
        <ProtectedRoute>
          <StravaActivities />
        </ProtectedRoute>
      } />

      {/* ✨ AJOUTER CES 3 ROUTES */}
      <Route path="/create-challenge" element={
        <ProtectedRoute>
          <CreateChallenge />
        </ProtectedRoute>
      } />

      <Route path="/club/:clubId/challenges" element={
        <ClubChallenges />
      } />

      <Route path="/challenge/:id" element={
        <ChallengePage />
      } />

      <Route path="/updates" element={<Updates />} />
      <Route path="/admin/updates" element={
        <ProtectedRoute>
          <AdminUpdates />
        </ProtectedRoute>
      } />

      <Route path="/user/:id" element={<UserProfile />} />
      <Route path="/club/:id" element={<ClubPage />} />
      <Route path="/map" element={<MapView />} />
      <Route path="/club-war/:warId" element={<ClubWarPage />} />
      <Route path="/clubs/leaderboard" element={<ClubsLeaderboard />} />
      <Route path="/global-leaderboard" element={<GlobalLeaderboard />} />
      <Route path="/find-friends" element={<FindFriends />} />
      <Route path="/clubs-list" element={<ClubsListPage/>}/>
      <Route path="/support" element={<Support />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
        <Analytics />
      </AuthProvider>
    </Router>
  );
}

export default App;